import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Form, Input, Button, Typography, notification } from "antd";
import { MailOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import authService from "../services/auth-service";
import { COMPANY_LOGO } from "../constants";

const { Title } = Typography;

const ForgotPassword = () => {

  let [form] = Form.useForm();
  let location = useLocation();

  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true)
    const response = await authService.forgotPassword(values);
    setLoading(false)

    if (response?.success ?? false) {
      notification.success({ message: "Success", description: response.message, placement: "topRight" });
    }
  }

  const onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "50vh",
      textAlign: "center",
    }}>
      {/* <img
        src={COMPANY_LOGO}
        alt="ctrade-Logo"
        className="h-10 w-auto"
        style={{ width: "370px", height: "120px" }}
      /> */}

      <Title id="title" style={{ fontSize: "20px" }}>Forgot Password </Title>
      <br />
      <h3 className="w-[65%]">Enter your registered email address, and we will send you a link to reset your password</h3>
      <br />
      <Form
        form={form}
        layout="vertical"
        style={{ width: "350px" }}
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{ email: location.state?.email ?? null }}
      >
        <Form.Item
          className="login-form-item"
          name="email"
          rules={[
            { type: "email", message: "The input is not valid email!" },
            { required: true, message: "Please input your email!" },
          ]}
        >
          <Input
            prefix={<MailOutlined />}
            type="email"
            style={{ borderRadius: "10px", height: "40px" }}
            placeholder="Enter your email"
            allowClear
          />
        </Form.Item>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Link to="/SignUp" className="text-blue text-black ">Remember your password?</Link>
          <Button style={{ width: "30%", borderRadius: "16px", height: "30px", }} type="primary" htmlType="submit" loading={loading}>
            Send
          </Button>
        </div>

      </Form>
    </div>
  );
};

export default ForgotPassword;
